import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPersonListQueryVariables = Types.Exact<{
  input: Types.GetPersonListInput;
}>;

export type GetPersonListQuery = {
  __typename?: 'Query';
  getPersonList: {
    __typename?: 'GetPersonListResponse';
    items: Array<{
      __typename?: 'GetPersonListResponsePerson';
      createdAt: string;
      firstName: string;
      lastName: string;
      uuid: string;
      email: string;
      role?: {
        __typename?: 'GetPersonListResponsePersonRole';
        name: string;
        uuid: string;
      } | null;
      status: {
        __typename?: 'GetPersonListResponsePersonStatus';
        name: string;
        uuid: string;
      };
    }>;
    pagination?: {
      __typename?: 'PaginationResponse';
      pageNumber: number;
      pageSize: number;
      total: number;
      totalPage: number;
    } | null;
  };
};

export const GetPersonListDocument = gql`
  query GetPersonList($input: GetPersonListInput!) {
    getPersonList(input: $input) {
      items {
        createdAt
        firstName
        lastName
        role {
          name
          uuid
        }
        status {
          name
          uuid
        }
        uuid
        email
      }
      pagination {
        pageNumber
        pageSize
        total
        totalPage
      }
    }
  }
`;
export function useGetPersonListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPersonListQuery,
    GetPersonListQueryVariables
  > &
    (
      | { variables: GetPersonListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPersonListQuery, GetPersonListQueryVariables>(
    GetPersonListDocument,
    options,
  );
}
export function useGetPersonListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPersonListQuery,
    GetPersonListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPersonListQuery, GetPersonListQueryVariables>(
    GetPersonListDocument,
    options,
  );
}
export function useGetPersonListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPersonListQuery,
        GetPersonListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPersonListQuery,
    GetPersonListQueryVariables
  >(GetPersonListDocument, options);
}
export type GetPersonListQueryHookResult = ReturnType<
  typeof useGetPersonListQuery
>;
export type GetPersonListLazyQueryHookResult = ReturnType<
  typeof useGetPersonListLazyQuery
>;
export type GetPersonListSuspenseQueryHookResult = ReturnType<
  typeof useGetPersonListSuspenseQuery
>;
export type GetPersonListQueryResult = Apollo.QueryResult<
  GetPersonListQuery,
  GetPersonListQueryVariables
>;
export function refetchGetPersonListQuery(
  variables: GetPersonListQueryVariables,
) {
  return { query: GetPersonListDocument, variables: variables };
}
